import { stringify } from 'query-string';

type Medication = {
  medNameId: string;
  name: string;
  popularity: number;
  slug: string;
};

type GetTopMedications = {
  type: 'medication-directory/GET_TOP_MEDICATIONS';
  data: { results: Medication[] };
};

type GetMedicationByLetter = {
  type: 'medication-directory/GET_MEDICATION_BY_LETTER';
  data: { results: Medication[] };
};

export type MedicationDirectoryAction = GetTopMedications | GetMedicationByLetter;

export type MedicationDirectoryState = {
  topMedications: Medication[];
  medicationsByLetter: Medication[];
};

const types = {
  GET_TOP_MEDICATIONS: 'medication-directory/GET_TOP_MEDICATIONS',
  GET_MEDICATION_BY_LETTER: 'medication-directory/GET_MEDICATION_BY_LETTER',
};
const initialState: MedicationDirectoryState = {
  topMedications: [],
  medicationsByLetter: [],
};

const getLetterQuery = (letter) => (letter === '0-9' ? '0' : letter);

export const getTopMedications = ({ limit = 100, letter = '' } = {}) => {
  return (dispatch, getState, { blinkAPIClient }) => {
    const queryParams = stringify({
      limit,
      letter: getLetterQuery(letter),
    });
    return blinkAPIClient.get(`/medications/top?${queryParams}`).then((response) =>
      dispatch({
        type: types.GET_TOP_MEDICATIONS,
        data: response.data,
      })
    );
  };
};
export const getMedicationsByLetter = ({ letter = '' } = {}) => {
  return (dispatch, getState, { blinkAPIClient }) => {
    return blinkAPIClient.get(`/medications/index/${getLetterQuery(letter)}`).then((response) =>
      dispatch({
        type: types.GET_MEDICATION_BY_LETTER,
        data: response.data,
      })
    );
  };
};

const medicationsReducer = (
  state: MedicationDirectoryState = initialState,
  action: MedicationDirectoryAction
): MedicationDirectoryState => {
  switch (action.type) {
    case types.GET_TOP_MEDICATIONS: {
      const { results: topMedications } = action.data || {};

      if (!topMedications && !topMedications.length) {
        return { ...state, topMedications: [] };
      }

      return { ...state, topMedications };
    }
    case types.GET_MEDICATION_BY_LETTER: {
      const { results: medicationsByLetter } = action.data || {};

      if (!medicationsByLetter && !medicationsByLetter.length) {
        return { ...state, medicationsByLetter: [] };
      }

      return { ...state, medicationsByLetter };
    }
    default:
      return state;
  }
};

export default medicationsReducer;
